import { Injectable } from '@angular/core';
import { ExportContext, ExportFileFormat, ExportRange, ExportService } from 'app/layout/export-overlay';
import { buildQuery, page, seed } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { BUSINESS_PARTNER_TERRITORIES_EXPORT_ID, BUSINESS_PARTNER_TERRITORIES_TITLE, LOCALIZED_PROPERTIES_TERRITORIES } from './business-partner.constants';
import { BusinessPartnerService } from '../business-partner.service';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';

@Injectable()
export class BusinessPartnerTerritorieExport {
  constructor(
    private exportService: ExportService,
    private businessPartnerService: BusinessPartnerService
  ) {}

private transformItem(item: BusinessPartnerAttributes, action: string) {
  const externalKeys = item?.externalKeys?.code ?? "";
  const name = item?.name ?? "";
  const dni = item?.DNI ?? "";
  const addresses = item?.addresses ?? [];

  if (!Array.isArray(addresses) || addresses.length === 0) {
    return [
      {
        externalKeys,
        name,
        dni,
        address: "",
        addressCode: "",
        territorie: "",
        country: "",
        department: "",
        city: "",
        district: "",
        isPrincipal: "",
        action: ""
      },
    ];
  }

  const rows: any[] = [];

  addresses.forEach(address => {
    const routes = Array.isArray(address?.routes) ? address.routes : [];

    // Si NO tiene rutas → crear una sola fila por dirección
    if (routes.length === 0) {
      rows.push({
        externalKeys,
        name,
        dni,
        address: address?.address ?? "",
        addressCode: address?.code || address.externalKeys?.code || "",
        territorie: "",
        country: address?.locationOne?.name ?? "",
        department: address?.locationTwo?.name ?? "",
        city: address?.locationThree?.name ?? "",
        district: address?.locationFour?.name ?? "",
        isPrincipal: address?.isPrincipal ? "Sí" : "No",
        isPrincipalBP: "",
        action
      });
    } else {
      // Si tiene rutas → crear una fila por cada ruta
      routes.forEach(route => {
        rows.push({
          externalKeys,
          name,
          dni,
          address: address?.address ?? "",
          addressCode: address?.code || address.externalKeys?.code || "",
          territorie: route?.externalKeys?.code ?? "",
          country: address?.locationOne?.name ?? "",
          department: address?.locationTwo?.name ?? "",
          city: address?.locationThree?.name ?? "",
          district: address?.locationFour?.name ?? "",
          isPrincipal: address?.isPrincipal ? "Sí" : "No",
          isPrincipalBP: "",
          action
        });
      });
    }
  });

  return rows;
}


  export(
    format: ExportFileFormat,
    range: ExportRange,
    totalItems: number,
    pageSize: number,
    pageIndex: number,
    geolocationPoint: string,
    action:string,
  ) {
    console.log(totalItems)
    const mainBatchSize = 500;
    const subBatchSize = 100;
    const totalPages = Math.ceil(totalItems / mainBatchSize);

    this.exportService
      .task({
        id: BUSINESS_PARTNER_TERRITORIES_EXPORT_ID,
        title: BUSINESS_PARTNER_TERRITORIES_TITLE,
        format: format,
        iterations: range === ExportRange.AllPages ? totalPages : 1,
        start: (ctx: ExportContext) => {
          ctx.processor.localizeItemProperties(
            BUSINESS_PARTNER_TERRITORIES_TITLE,
            LOCALIZED_PROPERTIES_TERRITORIES
          );
        },
        next: async (ctx: ExportContext) => {
          const currentPage =
            range === ExportRange.AllPages ? ctx.iteration : pageIndex;

          const response = await this.businessPartnerService
            .findByFilter(
              buildQuery(
                seed(this.businessPartnerService.currentFilter),
                page(currentPage, mainBatchSize)
              ),
              geolocationPoint,
              { contextHeader: "export" }
            )
            .toPromise();

          const items = response?.data?.[0]?.data ?? [];

          // Procesar items en sub-batches secuenciales
          for (let i = 0; i < items.length; i += subBatchSize) {
            const subBatch = items.slice(i, i + subBatchSize);
            for (const item of subBatch) {
              ctx.processor.addToSection(
                BUSINESS_PARTNER_TERRITORIES_TITLE,
                this.transformItem(item,action)
              );
            }
            // Evitar bloqueo de UI
            await new Promise((res) => setTimeout(res, 0));
          }

          ctx.next();
        },
      })
      .start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(BUSINESS_PARTNER_TERRITORIES_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }

}
